import axios from "axios";

const resourceClient = (() => {
  return axios.create({
    baseURL: 'https://static.uniess.co.kr',
  })
})()

export default resourceClient
